<!-- =========================================================================================
  File Name: AddNewDataSidebar.vue
  Description: Add New Data - Sidebar component
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <vs-sidebar click-not-close position-right parent="body" default-index="1" color="primary" class="add-new-data-sidebar items-no-padding" spacer v-model="isSidebarActiveLocal">
    <div class="mt-6 flex items-center justify-between px-6">
        <h4>Groupe</h4>
        <feather-icon icon="XIcon" @click.stop="isSidebarActiveLocal = false" class="cursor-pointer"></feather-icon>
    </div>
  
    <vs-divider class="mb-0"></vs-divider>

    <VuePerfectScrollbar class="scroll-area--data-list-add-new" :settings="settings" :key="$vs.rtl">

      <div class="p-6">

        

        <!-- Numero -->
        <vs-input  v-validate="'numeric|required'" label="numeric"  v-model="dataNumero" class="mt-5 w-full" />
        <span class="text-danger text-sm" v-show="errors.has('numeric')">{{ errors.first('numeric') }}</span>
        <!-- nb_place -->
        <vs-input v-validate="'numeric|required'"  label="nb_place"  v-model="dataNb_place" class="mt-5 w-full" />
        <span class="text-danger text-sm" v-show="errors.has('nb_place')">{{ errors.first('nb_place') }}</span>
        <!-- date -->
        <div class="mt-5 w-full">
          <p class="ml-2">date débit</p>
        <flat-pickr   v-model="fromDate"  @on-change="onFromChange" v-validate="'required'" />
        </div>
        <div class="mt-5 w-full">
          <p class="ml-2">date fin</p>
        <flat-pickr   v-model="toDate"  @on-change="onFromChange" v-validate="'required'"/>
        </div>
        
        <!-- formateur-->
        <div class="mt-5">
          <label class="text-sm opacity-75">formateur</label>
          <v-select :options="formateur_choices" :clearable="false" :dir="$vs.rtl ? 'rtl' : 'ltr'" v-model="formateur_data" class="mb-4 md:mb-0" />
        </div>
        <!-- formation -->
        <div class="mt-5">
          <label class="text-sm opacity-75">formation</label>
          <v-select :options="formation_choices" :clearable="false" :dir="$vs.rtl ? 'rtl' : 'ltr'" v-model="formation_data" class="mb-4 md:mb-0" />
        </div>
        
      </div>
    </VuePerfectScrollbar>

    <div class="flex flex-wrap items-center p-6" slot="footer">
      <vs-button class="mr-6" @click="submitData" :disabled="!isFormValid">Submit</vs-button>
      <vs-button type="border" color="danger" @click="isSidebarActiveLocal = false">Cancel</vs-button>
    </div>
  </vs-sidebar>
</template>

<script>
import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';
import vSelect from 'vue-select'
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import moduleformation from '@/store/formation/moduleformation.js'
import moduleformateur from '@/store/formateur/moduleformateur.js'
export default {
  props: {
    isSidebarActive: {
      type: Boolean,
      required: true
    },
    data: {
      type: Object,
      default: () => {},
    }
  },
  watch: {
    domaineFilter(obj) {
      this.setColumnFilter("nom_domaine", obj.value)
    },
    isSidebarActive(val) {
     
      if(!val) return
      if(Object.entries(this.data).length === 0) {
        let idnew = JSON.parse(JSON.stringify(this.data))
        console.log('idnew',idnew)
        console.log(this.data)
        this.initValues()
        this.$validator.reset()
      }else {
        let { nom,titre,id,nb_place, numero, date_debit, date_fin, formation_id, formateur_id } = JSON.parse(JSON.stringify(this.data))
        this.dataId = id
        this.dataNb_place = nb_place
        this.dataNumero = numero
        this.fromDate = date_debit
        this.toDate = date_fin
        this.formation_data = {label: titre, value: formation_id}
        this.formateur_data = {label: nom, value: formateur_id}
        console.log('gg',date_fin)
        console.log(this.toDate)
        //this.initValues()
       
      }
      // Object.entries(this.data).length === 0 ? this.initValues() : { this.dataId, this.dataName, this.dataCategory, this.dataOrder_status, this.dataPrice } = JSON.parse(JSON.stringify(this.data))
    }
  },
  data() {
    return {
            fromDate: null,
            toDate: null,
            configFromdateTimePicker: {
              minDate: new Date(),
              maxDate: null
            },
            configTodateTimePicker: {
              minDate: null
            },
      formation_data: null,
      formateur_data: null,
      dateDefault: null,
      change_image: false,
      newformation: false,
      file: null, 
      dataTitre: null, 
      datadomaine: null,
      datadescription: null,
      dataprix: null,
      dataId: null,
      dataAvatar: null,
      dataOrder_status: "pending",
      dataPrice: 0,
      dataNumero: null,
      dataNb_place: null,
      settings: { // perfectscrollbar settings
          maxScrollbarLength: 60,
          wheelSpeed: .60,
      },
    }
  },
  computed: {
    formateur_choices() {
        let opts=[];
          for (var formateur of this.$store.state.formateur.users) {
              opts.push({label:formateur.prenom+' '+formateur.nom, value: formateur.id});
              
            }
      return opts
    },
    formation_choices() {
        let opts=[];
          for (var formation of this.$store.state.formation.users) {
              opts.push({label: formation.titre, value: formation.id});
              
            }
      console.log(opts)
      return opts
    },
    isSidebarActiveLocal: {
      get() {
        console.log(this.isSidebarActive)
        return this.isSidebarActive
      },
      set(val) {
        if(!val) {
          this.$emit('closeSidebar')
          // this.$validator.reset()
           this.initValues()
        }
      }
      
    },
    
    /*formateur_choices() {
        let opts=[];
          for (var formateur of this.$store.state.formateur.users) {
              opts.push({text: formateur.nom, value: formateur.id});
              
            }
        console.log('opts',opts)      
      return opts
    },
    formateur_local: {
      get() {
        console.log('this.dataNom_domaine')
        return { text: this.dataFormarteurNom,  value: this.dataFormarteurId  }
      },
      set(obj) {
        this.dataFormarteurNom = obj.label
        this.dataFormarteurId = obj.value
        console.log('this.dataNom_domaine')
      }
    },
    formation_choices() {
        let opts=[];
          for (var formation of this.$store.state.formation.users) {
              opts.push({text: formation.titre, value: formation.id});
              
            }
            
      return opts
    },
    formartion_local: {
      get() {
        console.log(this.dataFormateurTitre)
        return { text: this.dataFormationTitre,  value: this.dataFormationId  }
      },
      set(obj) {
        this.dataFormateurTitre = obj.label
        this.dataFormateurId = obj.value
        console.log('this.dataNom_domaine')
      }
    },*/
    isFormValid() {
      return !this.errors.any() 
    }
  },
  methods: {
    onFromChange(selectedDates, dateStr, instance) {
        this.$set(this.configTodateTimePicker, 'minDate', dateStr);
      },
      onToChange(selectedDates, dateStr, instance) {
        this.$set(this.configFromdateTimePicker, 'maxDate', dateStr);
      },
    initValues() {
      console.log('initValues')
      /*if(this.data.id) return*/
        this.dataId = null
        this.dataNb_place = null
        this.dataNumero = null
        this.fromDate = null
        this.toDate = null
        this.formation_data = null
        this.formateur_data = null
    },
    submitData() {
      this.$validator.validateAll().then(result => {
          this.newformation= true
          console.log('this.newformation',this.newformation)
          if (result) {
            const obj = {
              id: this.dataId,
              nb_place: this.dataNb_place,
              numero: this.dataNumero,
              date_debit: this.fromDate,
              date_fin: this.toDate,

              formation_id: this.formation_data.value,
              formateur_id: this.formateur_data.value
            }  
            const objj = {    
              id: this.data,
              formateur_id: this.formateur_data.value,
              rembourser : 0
            }
         console.log('obj',objj)
            //this.$store.dispatch("formation/addItem", obj).catch(err => { console.error(err) });    
            //this.showMessage('success', 'Added', 'successfully added') }).catch(err => { console.error(err); this.activeLoading = false; this.$vs.loading.close(); this.showMessage('danger', 'not Added', 'an error in add: '+ err) })
              //let Particpation = null
              //this.$store.dispatch("formation/addItem", obj).catch(err => { console.error(err) })
              if(!obj.id){
              this.$store.dispatch("classe/addItem", obj).then(()   => {  this.$store.dispatch("classe/fetchUsers").catch(err => { console.error(err) });  this.showMessage('success', 'Added', 'successfully added') }).catch(err => { console.error(err); this.activeLoading = false; this.$vs.loading.close(); this.showMessage('danger', 'not Added', 'an error in add: '+ err) })
              //this.$store.dispatch("classe/addParticpation_formateur_class", objj).then(()   => {  this.$store.dispatch("classe/fetchUsers").catch(err => { console.error(err) });  this.showMessage('success', 'Added', 'successfully added') }).catch(err => { console.error(err); this.activeLoading = false; this.$vs.loading.close(); this.showMessage('danger', 'not Added', 'an error in add: '+ err) })
              }else{
                console.log('obj2',obj)
                console.log('obj.avatar',obj.avatar)
               this.$store.dispatch("classe/updateRecord", obj).then(()   => {  this.$store.dispatch("classe/fetchUsers").catch(err => { console.error(err) });  this.showMessage('success', 'Update', 'successfully Update') }).catch(err => { console.error(err); this.activeLoading = false; this.$vs.loading.close(); this.showMessage('danger', 'not update', 'an error in update: '+ err) })
               
              }

            this.$emit('closeSidebar')
            this.initValues()
            console.log(this.data)
            //const image = this.file
            //axios.post('http://127.0.0.1:8000/api/addformation',obj,image)
          }
      })
    
    },
    showMessage(color, title, text) {
              this.$vs.notify({
                color: color,
                title: 'User '+title,
                text: 'The new user was '+text
              })
            },
  
  },
  components: {
    VuePerfectScrollbar,
    flatPickr,
    vSelect
  },
  created() {
     
  if(!moduleformation.isRegistered) {
      this.$store.registerModule('formation', moduleformation)
      moduleformation.isRegistered = true
    }
   this.$store.dispatch("formation/fetchUsers").catch(err => { console.error(err) })
  if(!moduleformateur.isRegistered) {
      this.$store.registerModule('formateur', moduleformateur)
      moduleformateur.isRegistered = true
    }
   this.$store.dispatch("formateur/fetchUsers").catch(err => { console.error(err) })
  console.log(this.$store.state)

  }

    
  
}
</script>

<style lang="scss" scoped>
.add-new-data-sidebar {
  ::v-deep .vs-sidebar--background {
    z-index: 52010;
  }

  ::v-deep .vs-sidebar {
    z-index: 52010;
    width: 400px;
    max-width: 90vw;

    .img-upload {
      margin-top: 2rem;

      .con-img-upload {
        padding: 0;
      }

      .con-input-upload {
        width: 100%;
        margin: 0;
      }
    }
  }
}

.scroll-area--data-list-add-new {
    // height: calc(var(--vh, 1vh) * 100 - 4.3rem);
    height: calc(var(--vh, 1vh) * 100 - 16px - 45px - 82px);
}
</style>
